import {
  Box,
  Card,
  CardMedia,
  CircularProgress,
  ImageListItemBar,
  Stack,
  Typography,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import React from "react";
import useFetchImgs from "../useFetchImgs";
import { TIFFViewer } from "react-tiff";

function SinglePDImage({ img_url, watermark_img = false, cover_img = false }) {
  // const isTiff =
  //   img_url.toLowerCase().endsWith(".tif") ||
  //   img_url.toLowerCase().endsWith(".tiff");
  // const isTiff = img_url.includes(".tif")

  const isTiff = false;
  // console.log(img_url);

  // const flag = img_url.includes("data/auto_phase2/files/000206693819A/1A05480264744B53AD84B8914A2A8EC51023CA_3.tiff");
  // if(flag) {
  //   console.log("Flag is true, showing TIFFViewer");
  // }
  return (
    <Box sx={{ position: "relative", maxWidth: "50%" }}>
      {isTiff ? (
        <Box
          sx={{
            "& canvas": {
              maxHeight: 700,
              maxWidth: "100%",
              width: "auto",
              height: "auto",
              display: "block",
              margin: "0 auto",
            },
          }}
        >
          <TIFFViewer
            tiff={img_url}
            style={{
              // These styles go to the TIFFViewer's *outer* div
              // maxHeight: "650px",
              // maxWidth: "100%",
              // width: "auto",
              // height: "auto",
              // display: "block",
              // margin: "0 auto",
            }}
          />
        </Box>
      ) : (
        <Box
          component="img"
          sx={{
            width: "100%",
            maxHeight: 700,
            objectFit: "contain",
            cursor: "pointer",
            border: 0,
            display: "block",
            boxShadow: 4,
          }}
          alt="img_path"
          src={img_url}
        />
      )}

      {watermark_img && (
        <Stack
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            color: "white",

            zIndex: 3,
          }}
        >
          <Typography sx={{ fontSize: "1.5rem", fontWeight: "bold" }}>
            SKIPPED PAGE
          </Typography>
          <Typography
            align="center"
            sx={{ px: 1, fontSize: "1.1rem", fontWeight: "bold" }}
          >
            (No comparison made to other document)
          </Typography>
        </Stack>
      )}
      {cover_img && (
        <Stack
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: grey[300],
            border: 1,
            borderColor: grey[100],
            color: "white",
            zIndex: 3,
          }}
        ></Stack>
      )}
    </Box>
  );
}

function PDImage({
  bottom_margin = 0,
  img1_path,
  img2_path,
  watermark_img1 = false,
  watermark_img2 = false,
  blank_img1 = false,
  blank_img2 = false,
}) {
  const {
    results: pre_signed_urls,
    loading,
    error,
  } = useFetchImgs(img1_path, img2_path);

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: "red", // Display error message in red
        }}
      >
        <p>An error occurred while fetching images: {error.message}</p>
      </Box>
    );
  }

  return (
    <Stack
      sx={{
        mt: bottom_margin,
        border: 0,
        alignItems: "center",
        justifyContent: "center",
      }}
      direction={"row"}
      spacing={1}
    >
      <SinglePDImage
        img_url={!blank_img1 ? pre_signed_urls.img1 : pre_signed_urls.img2}
        watermark_img={watermark_img1}
        cover_img={blank_img1}
      />
      <SinglePDImage
        img_url={!blank_img2 ? pre_signed_urls.img2 : pre_signed_urls.img1}
        watermark_img={watermark_img2}
        cover_img={blank_img2}
      />
    </Stack>
  );
}

export default PDImage;
